<template lang="pug">
  .reset-password
    .top-wrap
      p.sign-in-title.kapra-neue.upper.xs-f-xgrande.max-at-tweak Create a Password
      p.text-color-2.xs-f-small.max-at-tweak Enter a new secure password for your account

    form#create_password(name='create_password' @submit.prevent="resetPassword" novalidate)
      p.xs-f-small.max-at-tweak Create your password
      .mr-input-wrap
        MrPasswordInput(v-model="password" :required="true" :show-confirm-password="true" :confirm-password="confirmPassword" @confirm-password-input="(value) => confirmPassword = value"  autocomplete="current-password" data-mr-ass="sign-in-password" name='password')

      mrInput(:inputType="'hidden'" :name="'code'" :model-value='code')

      .captcha(v-if="showCaptcha")
        Captcha(@captcha-response="setCaptchaResponse")

      button.mr-btn.btn-block.font-xsmall(type='submit' :disabled="v$.$invalid || processing" :class="{ disabled: v$.$invalid || processing }" data-mr-ass="sign-in") Continue

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import { required, sameAs } from "@vuelidate/validators";

  import Captcha from "@components/captcha";
  import MrPasswordInput from '@components/MrPasswordInput';
  import mrInput from '@components/mrInput';
  import { useVuelidate } from "@vuelidate/core";

  export default {
    name: "ResetPassword",

    components: {
      Captcha,
      MrPasswordInput,
      mrInput,
    },

    data() {
      return {
        verifying: true
      };
    },

    setup () {
      return {
        v$: useVuelidate()
      };
    },

    computed: {
      ...mapState('signIn', [
        'userEmail',
        'code',
        'processing',
        'showCaptcha',
        'userPassword',
        'confirmNewPassword',
        'passwordValidators',
      ]),

      password: {
        get() {
          return this.userPassword;
        },

        set(value) {
          this.setUserPassword(value);
        }
      },

      confirmPassword: {
        get() {
          return this.confirmNewPassword;
        },

        set(val) {
          this.setConfirmNewPassword(val);
        }
      },
    },

    validations() {
      return {
        password: this.passwordValidators,
        confirmPassword: {
          required,
          passwordSameAs: sameAs(this.password)
        }
      };
    },

    methods: {
      ...mapActions('signIn', [
        'resetPassword'
      ]),

      ...mapMutations('signIn', [
        'setUserPassword',
        'setConfirmNewPassword',
        'setCaptchaResponse'
      ])
    }
  };
</script>

<style scoped lang="stylus">
</style>
